import React, {useEffect, useState} from 'react'
import RequestUpdateProvider from "./RequestUpdateProvider"
import RequestUpdateFilters from "./RequestUpdateFilters"
import RequestUpdateTable from "./RequestUpdateTable"
import {getListRequests} from "../../../services/api/RequestsService"
import ExportRequestGoogleSheet from './exports/ExportRequestGoogleSheet'

function RequestUpdatePage(props) {
    const [page, _setPage] = useState(1)
    const [limit, _setLimit] = useState(50)
    const [loading, _setLoading] = useState(true)
    const [total, _setTotal] = useState(0)
    const [error, _setError] = useState('')
    const [requestUpdateLists, _setRequestUpdateLists] = useState([])
    const [filters, _setFilters] = useState({sources: ['fac', 'tool3d']})

    const _hadleSetState = (filters) => {
        _setFilters(filters)
        _setPage(1)
    }

    const _fetchListRequestUpdate = async () => {
        try {
            _setLoading(true)
            _setError('')

            const payload = {
                ...filters,
                limit,
                page: page
            }

            const {data, success, message} = await getListRequests(payload)

            if (!success) {
                _setLoading(false)
                _setRequestUpdateLists([])
                return _setError(message)
            }

            const {requests, total} = data

            _setRequestUpdateLists(requests)

            _setLoading(false)
            _setError('')
            _setTotal(total)
        } catch (e) {
            _setLoading(false)
            _setError(e.message)
        }
    }

    const _handleSetPage = (page) => {
        _setPage(page)
    }

    const _handleSetSize = (size) => {
        _setLimit(size)
    }

    useEffect(() => {
        _fetchListRequestUpdate()
    }, [limit, page, filters]) // eslint-disable-line react-hooks/exhaustive-deps


    return (
        <RequestUpdateProvider filters={filters} setState={_hadleSetState} loadShippingRules={_fetchListRequestUpdate}>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h1 className="card-title mb-0">Request Update</h1>

                <ExportRequestGoogleSheet filters={filters}/>
            </div>
            <div className="card RequestUpdatePage">
                <div className="card-body">
                    <div className="ShippingRuleFilters">
                        <RequestUpdateFilters/>
                    </div>

                    <div>
                        {
                            error && <div className="text-danger">{error}</div>
                        }

                        <RequestUpdateTable
                            loading={loading}
                            limit={limit}
                            page={page}
                            total={total}
                            requestUpdate={requestUpdateLists}
                            onChangeSize={_handleSetSize}
                            onChangePage={_handleSetPage}
                        />
                    </div>
                </div>
            </div>
        </RequestUpdateProvider>
    )
}

export default RequestUpdatePage
